import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

import { getScenario } from 'actions/asyncActions';
import { getScormLink } from 'constants/urls';
import { modalPropTypes } from 'components/Modals';

@withAsyncActions({ getScenario: getScenario
    .withPayload(({ params: { objkey, cmd, objtype } }) => ({ objkey, cmd, objtype })) })
export default class ScormModal extends Component {
    static propTypes = {
        ...modalPropTypes,
        params: PropTypes.shape({
            folder: PropTypes.number.isRequired,
            cmd: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            token: PropTypes.string,
            objtype: PropTypes.string.isRequired,
            objkey: PropTypes.number.isRequired
        }),
        getScenario: PropTypes.object.isRequired
    }

    render() {
        const { params: { folder, cmd, token, name }, modal, getScenario: { refresh } } = this.props;
        const afterClose = () => {
            modal.afterClose();
            refresh();
        };

        return (
            <Modal
                {...modal}
                footer={null}
                afterClose={afterClose}
                title={name}
                className="modal-full card-modal scorm-modal">
                <iframe
                    src={getScormLink(token, folder, cmd)}
                    frameBorder="0"
                    height="98%"
                    width="100%"
                />
            </Modal>
        )
    }
}
